
<script>
import { capitalize } from '_utils';
import PuzzleService from '_services/rest/modules/puzzle';

export default {
  name: 'puzzle-fill-table',
  data() {
    return {
      respo: false,
      valid: false,
    };
  },
  computed: {},
  methods: {
    getCellIndex(cell) {
      // const index = this.model.table.findIndex(item => item.positionx === cell.positionx && item.positiony === cell.positiony);
      // return index;
      let { positiony } = cell;
      if (Number.isNaN(Number(positiony))) {
        [positiony] = positiony.split('_');
      }
      const diff = (parseInt(positiony, 0) > 0) ? 10 - this.model.columns : 0;
      const index = ((parseInt(positiony, 0) * 10) + parseInt(cell.positionx, 0)) - (parseInt(positiony, 0) * diff);
      return index;
    },
    getInitialCell(optionSelected) {
      if (['right', 'bottom'].includes(optionSelected)) {
        return 1;
      }
      if (['left', 'top'].includes(optionSelected)) {
        return -1;
      }

      return 0;
    },
    incrementInitialPosition(index, directions, start = 1, sequence = this.model.columns) {
      // TODO :: Refactoring merge incrementInitialPosition and decrementInitialPosition
      const size = directions.length;

      let initial = ([1, 3].includes(size)) ? index + start : index;
      let rowspan = this.model.table[index].type.indexOf('rowspan') > -1 && directions.includes('bottom') ? 2 : 1;

      if (size > 1) {
        initial += (sequence * rowspan) * this.getInitialCell(directions[1]);
      }

      if (size === 3) {
        rowspan = (directions.includes('secondRow')) ? start : rowspan;
        initial += (sequence * rowspan) * this.getInitialCell(directions[2]);
      }

      if (size === 1 && this.model.table[initial].hide) {
        initial += start;
      }
      return initial;
    },
    decrementInitialPosition(index, directions, rows = 0, childIndex = false) {
      const size = directions.length;
      let initial = ([1, 3].includes(size)) ? parseInt(index, 0) + parseInt(rows, 0) : parseInt(index, 0);
      const rowspan = this.model.table[index].type.includes('rowspan') && directions.includes('bottom') ? 2 : 1;

      if (size > 1) {
        initial += (this.getInitialCell(directions[1]) * rowspan);
      }

      if (size === 3) {
        initial += (this.getInitialCell(directions[2]) * rowspan);
      }

      if (size === 1 && this.model.table[initial].hide) {
        initial += rows;
      }
      if (childIndex && Number.isNaN(Number(childIndex))) {
        const child = childIndex.split('_')[0];
        const active = this.getActiveCell(index);
        if (this.model.table[index].children[child].type === 'colspan_col' && active === 1) {
          initial += 1;
        }
      }
      return initial;
    },
    getActiveCell(index) {
      return this.model.table[index].children.findIndex(item => {
        if (item.active) return true;
        if (item.children.length > 0) {
          return item.children.findIndex(child => child.active);
        }
        return false;
      });
    },
    checkIfAnswerFitInRow(index, numberOfAnswerChar) {
      const position = this.model.table[index].positionx + numberOfAnswerChar;
      if (position < 0 || position > this.model.columns) {
        this.activeAlert({ message: 'Palavra grande demais', theme: 'danger' });
        return false;
      }
      return true;
    },
    checkIfAnswerFitInTable(index, numberOfAnswerChar) {
      const position = index + numberOfAnswerChar;
      if (!this.model.table[position]) {
        this.activeAlert({ message: 'Palavra grande demais', theme: 'danger' });
        return false;
      }
      return true;
    },
    checkIfHasOtherAnswer(position) {
      const { answer: cellAnswer } = this.model.table[position];
      if (!cellAnswer || cellAnswer.answer !== null) {
        // TODO :: Refactoring the confirm to confirmation-modal
        // eslint-disable-next-line
        this.respo = confirm('Há uma resposta nesta direção, tem certeza que deseja continuar?');
        return this.respo;
      }
      return true;
    },
    loopTopAnswer(initial, callback) {
      let next = initial;
      while (this.model.table[next].isAnswer && this.model.table[next].positionx === this.model.table[initial].positionx) {
        callback(this.model.table[next]);
        next -= parseInt(this.model.columns, 0);
        if (next <= 0) break;
      }
    },
    loopBottomAnswer(initial, callback) {
      let next = initial;
      while (this.model.table[next].isAnswer && this.model.table[next].positionx === this.model.table[initial].positionx) {
        callback(this.model.table[next]);
        next += parseInt(this.model.columns, 0);
        if (next >= this.model.table.length) break;
      }
    },
    loopRightAnswer(initial, callback) {
      let next = initial;
      while (this.model.table[next].isAnswer && this.model.table[next].positiony === this.model.table[initial].positiony) {
        callback(this.model.table[next]);
        next += 1;
        if (next >= this.model.table.length) break;
      }
    },
    loopLeftAnswer(initial, callback) {
      let next = initial;
      while (this.model.table[next].isAnswer && this.model.table[next].positiony === this.model.table[initial].positiony) {
        callback(this.model.table[next]);
        next -= 1;
        if (next <= 0) break;
      }
    },
    getCellAnswer(index, childIndex = null) {
      if (childIndex !== null) {
        if (Number.isNaN(Number(childIndex))) {
          const [child, grandson] = childIndex.split('_');
          return this.model.table[index].children[child].children[grandson];
        }
        return this.model.table[index].children[childIndex];
      }
      return this.model.table[index];
    },
    topAnswer(index, directions, childIndex = null) {
      const initial = this.decrementInitialPosition(index, directions, -this.model.columns);
      let word = '';
      this.loopTopAnswer(initial, cell => {
        word += cell.text;
      });
      word = word.split('').reverse().join('');
      this.saveAnswer(index, childIndex, word)
        .then(response => {
          this.loopTopAnswer(initial, cell => {
            cell.answer_id = response.id;
            cell.updated = true;
          });
        });
      return true;
    },
    bottomAnswer(index, directions, childIndex = null) {
      const initial = this.decrementInitialPosition(index, directions, this.model.columns, childIndex);
      let word = '';
      this.loopBottomAnswer(initial, cell => {
        word += cell.text;
      });
      this.saveAnswer(index, childIndex, word)
        .then(response => {
          this.loopBottomAnswer(initial, cell => {
            cell.answer_id = response.id;
            cell.updated = true;
          });
        });
      return true;
    },
    leftAnswer(index, directions, childIndex = null) {
      const initial = this.incrementInitialPosition(index, directions, -1);
      let word = '';
      this.loopLeftAnswer(initial, cell => {
        word += cell.text;
      });
      word = word.split('').reverse().join('');
      this.saveAnswer(index, childIndex, word)
        .then(response => {
          this.loopLeftAnswer(initial, cell => {
            cell.answer_id = response.id;
            cell.updated = true;
          });
        });
      return true;
    },
    rightAnswer(index, directions, childIndex = null) {
      const initial = this.incrementInitialPosition(index, directions, 1, this.model.columns);
      let word = '';
      this.loopRightAnswer(initial, cell => {
        word += cell.text;
      });
      this.saveAnswer(index, childIndex, word)
        .then(response => {
          this.loopRightAnswer(initial, cell => {
            cell.answer_id = response.id;
            cell.updated = true;
          });
        });
      return true;
    },
    saveAnswer(index, childIndex, word) {
      const answer = { id: null, answer: capitalize(word) };
      return PuzzleService.saveAnswer(answer)
        .then(response => {
          const cell = this.getCellAnswer(index, childIndex);
          cell.answer = response;
          cell.answer_id = response.id;
          cell.direction_id = cell.direction.id;
          cell.updated = true;
          this.setQuestionIfHasOneOrMore(response, cell);
          this.setArrowInCell(cell);
          return response;
        });
    },
    getPositionArrowByAnswer(direction) {
      const directions = direction.split('_');
      if (directions.length > 2) {
        return direction;
      }
      return directions.pop();
    },
    setArrowInCell(cell) {
      const position = this.getPositionArrowByAnswer(cell.direction.slug);
      const [arrowPosition] = this.$store.state.puzzle.arrowPositions.filter(item => (
        JSON.stringify(position.split('_').sort()) === JSON.stringify(item.slug.split('_').sort())
      ));
      cell.arrow_position = arrowPosition;
      cell.arrow_position_id = arrowPosition.id;

      const first = cell.direction.slug.split('_').shift();
      const [arrowDirection] = this.$store.state.puzzle.arrowDirections.filter(dir => dir.slug === first);
      cell.arrow_direction = arrowDirection;
      cell.arrow_direction_id = arrowDirection.id;
    },
    setQuestionIfHasOneOrMore(answer, cell) {
      if (answer.questions.length > 0) {
        [cell.question] = answer.questions;
        cell.question_id = cell.question.id;
        cell.text = cell.question.question;
      }
    },
  },
};

</script>
